'use client'

/* eslint-disable react/no-unstable-nested-components */
import dynamic from 'next/dynamic'
import React, { useEffect, useState } from 'react'
import isMobile from 'ismobilejs'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import Shimmer from '@components/Shimmer/Shimmer'
import logger from '@utils/logger'
import { getLifeDetailsCompDynamically } from './LifeWidgetDynamicImport'
import styles from './lifeWidget.module.scss'

interface PropTypes {
  onHide?: any
  isBottomFloater?: boolean
  widgetCtaText?: string
  segmentEventCommonProperties?: any
  addScroll?: boolean
}

const LifeInputDetailsWidget = (props: PropTypes) => {
  const { onHide, isBottomFloater, widgetCtaText, segmentEventCommonProperties, addScroll } = props
  const [lifeInputOpen, setLifeInputOpen] = useState(false)
  const [LifeDynamicWidget, setLifeDynamicWidget] = useState<any>({})
  const [isMobileDevice, setIsMobileDevice] = useState<boolean | null>(null)
  const [LifeInputWidget, setLifeInputWidget] = useState<React.ComponentType | null>(null)

  useEffect(() => {
    const checkIsMobile = () => {
      const mobileDetect = isMobile(window.navigator)
      const isMobileDevice = mobileDetect.any // Detect any mobile device
      setIsMobileDevice(isMobileDevice)
    }
    checkIsMobile()
  }, [])

  useEffect(() => {
    if (isMobileDevice === false) {
      const DynamicComponent = dynamic(
        () => import('@acko-tech/acko-calculators.ui.sem-input').then(mod => mod.SemInput),
        {
          ssr: false,
          loading: () => <Shimmer />,
        }
      )
      setLifeInputWidget(() => DynamicComponent)
    }
  }, [isMobileDevice])

  useEffect(() => {
    // This is for trying to fix keyboard overlap the widget issue in ios
    document.body.addEventListener(
      'focus',
      event => {
        const target: any = event.target
        switch (target?.tagName) {
          case 'INPUT':
          case 'TEXTAREA':
          case 'SELECT':
            document.body.classList.add('keyboard')
        }
      },
      true
    )
    document.body.addEventListener(
      'blur',
      () => {
        document.body.classList.remove('keyboard')
      },
      true
    )
  }, [])

  useEffect(() => {
    getLifeDetailsCompDynamically(lifeInputOpen, setLifeDynamicWidget, isBottomFloater)
      .then(() => {})
      .catch(err => {
        logger.info('dynamic import error', err)
      })
  }, [lifeInputOpen, isBottomFloater])

  const segmentEvent = async () => {
    const properties = await segmentEventCommonPropFunc(segmentEventCommonProperties)
    await trackEvent('tap_btn_CTA_widget', {
      ...properties,
      funnel: 'entry',
    })
  }

  return (
    <div className={`${styles.widgetContainer} ${addScroll ? styles.addScroll : ''}`}>
      {!isBottomFloater &&
        (lifeInputOpen ? (
          LifeDynamicWidget.hasOwnProperty('Overlay') && (
            <LifeDynamicWidget.Overlay
              show
              handleClose={() => setLifeInputOpen(false)}
              onClick={() => segmentEvent()}
              regulatoryText="ARN: L0053 | *T&Cs Apply"
              headingText="Let's build a perfect life insurance cover for you"
              ctaText={widgetCtaText || 'Check prices'}
            />
          )
        ) : (
          <div className={styles.ButtonContainer}>
            <button type="button" className={styles.renderWidgetButton} onClick={() => setLifeInputOpen(true)}>
              <span>{widgetCtaText || 'Check prices'}</span>
            </button>
          </div>
        ))}

      {isBottomFloater && LifeDynamicWidget.hasOwnProperty('Overlay') && (
        <div className={styles.lifeWidgetVisibleMobile}>
          <LifeDynamicWidget.Overlay
            show
            handleClose={() => onHide()}
            regulatoryText="ARN: L0053 | *T&Cs Apply"
            headingText="Let's build a perfect life insurance cover for you"
            ctaText={widgetCtaText || 'Check prices'}
            onClick={() => segmentEvent()}
          />
        </div>
      )}

      <div className={styles.lifeWidgetVisibleDesktop}>
        {LifeInputWidget ? (
          <LifeInputWidget
            isMobile={false}
            regulatoryText="ARN: L0053 | *T&Cs Apply"
            headingText="Let's build a perfect life insurance cover for you"
            ctaText={widgetCtaText || 'Check prices'}
            onClick={() => segmentEvent()}
          />
        ) : (
          <Shimmer />
        )}
      </div>
    </div>
  )
}

export default LifeInputDetailsWidget
